import React from "react";
import SellersTable from "./SellersTable";

const PendingSellers = () => <SellersTable status="pending" />;

export default PendingSellers;
